import { render, staticRenderFns } from "./erweima.vue?vue&type=template&id=13b7f850&"
import script from "./erweima.vue?vue&type=script&lang=js&"
export * from "./erweima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports